import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "control-item-icon" }
const _hoisted_2 = { class: "control-item-detail" }
const _hoisted_3 = { class: "control-item-text" }

import { ref, onMounted, nextTick, withDefaults, toRefs, computed } from 'vue';
import TriangleSVG from '../icons/triangle.vue';
import "../style.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'ControlPanelItem',
  props: {
    action: null,
    hasDetail: { type: Boolean, default: false },
    size: { default: 'small' },
    isMobile: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { action: (payload: MouseEvent) => void, hasDetail: boolean, size: string, isMobile: boolean }

const openDetail = ref<boolean>(false);

const { action, hasDetail, isMobile, size } = toRefs(props);
const controlItemIconContainerClass = computed(() => `control-item-icon-container-${size.value}`)

onMounted(() => {
  document.documentElement.addEventListener('click', (e) => {
    openDetail.value = false;
  });
});

async function stayFocus() {
  await nextTick();
  const els = document.getElementsByClassName("control-item-detail");
  for (let el of els) {
    el.addEventListener('click', (e: any) => e.stopPropagation());
  }
}

const toggleDetail = (event: Event) => {
  event.stopPropagation();
  stayFocus();
  openDetail.value = !openDetail.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(isMobile) ? 'control-item-h5' : 'control-item')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(_unref(controlItemIconContainerClass)),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(action) && _unref(action)(...args)))
      }, [
        _renderSlot(_ctx.$slots, "icon")
      ], 2),
      (_unref(hasDetail))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "control-item-summary",
            onClick: toggleDetail
          }, [
            _createVNode(TriangleSVG)
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "detail")
      ], 512), [
        [_vShow, openDetail.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("text", null, [
        _renderSlot(_ctx.$slots, "text")
      ])
    ])
  ], 2))
}
}

})